export function cropRow(array: string[], maxLength = 25) {
  const newArray = [...array].sort((a, b) => a.length - b.length)
  let totalLength = 0
  const visibleArray: string[] = []
  let hiddenArray: string[] = []

  for (let i = 0; i < newArray.length; i++) {
    const country = newArray[i]
    totalLength += country.length + (i > 0 ? 2 : 0)

    if (totalLength <= maxLength) {
      visibleArray.push(country)
    } else {
      hiddenArray = newArray.slice(i)
      break
    }
  }

  return { visible: visibleArray.join(', '), hidden: hiddenArray }
}
